// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FA8hA","field":"styles_field__69sXq","fieldCol":"styles_fieldCol__wEbMy","diffCol":"styles_diffCol__24htI","diff":"styles_diff__35JSE"};